// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/742be95cecf7cc671cad.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cc4ee6bcf922dbfa0efa","191":"06db16de05a1b12e962b","192":"461f30cc4bd62cc2e487"}[chunkId] + ".chunk.js";
};